'use client';

type BuyNowButtonProps = {
  /** Fully-resolved CTA label (e.g. "Download Now for $33.00"). */
  label: string;
  /** Trigger the shared purchase/download flow. */
  onClick: () => void;
  /** Disabled while the access gate / auth is still resolving. */
  disabled?: boolean;
};

/**
 * Sticky bottom CTA — dark full-width button. Mirrors RN's `primaryButtonTitle`.
 * Purely presentational: the purchase/download flow (gating, checkout nav,
 * external open, in-app IAP alert) is owned by `PdpPurchaseProvider` and reached
 * through `onClick`.
 */
export function BuyNowButton({ label, onClick, disabled }: BuyNowButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="text-sub block w-full rounded-lg bg-neutral-900 px-4 py-3 text-white transition-opacity hover:opacity-95 disabled:opacity-60"
    >
      {label}
    </button>
  );
}
